import React, { useState } from 'react';
import { db } from '../firebase';
import { updateDoc, doc } from 'firebase/firestore';
import { FaSearch, FaEye, FaTimes, FaPhone, FaEnvelope, FaMapMarkerAlt, FaComment } from 'react-icons/fa';

function AdminOrders({ orders, onUpdate }) {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [adminComment, setAdminComment] = useState('');

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await updateDoc(doc(db, 'orders', orderId), { status: newStatus });
      onUpdate();
      if (selectedOrder?.id === orderId) {
        setSelectedOrder({...selectedOrder, status: newStatus});
      }
    } catch (error) {
      alert('Ошибка обновления статуса: ' + error.message);
    }
  };

  const handleAddComment = async (orderId) => {
    if (!adminComment.trim()) return;
    try {
      const comments = selectedOrder.adminComments || [];
      comments.push({
        text: adminComment,
        date: new Date().toISOString()
      });
      await updateDoc(doc(db, 'orders', orderId), { adminComments: comments });
      setAdminComment('');
      onUpdate();
      setSelectedOrder({...selectedOrder, adminComments: comments});
    } catch (error) {
      alert('Ошибка добавления комментария: ' + error.message);
    }
  };

  const filteredOrders = orders.filter(o => {
    const matchesSearch = 
      o.customer?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      o.customer?.phone?.includes(searchTerm);
    const matchesStatus = filterStatus === 'all' || o.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const getStatusColor = (status) => {
    switch(status) {
      case 'new': return '#ff6b6b';
      case 'processing': return '#4a90e2';
      case 'completed': return '#28a745';
      case 'cancelled': return '#6c757d';
      default: return '#6c757d';
    }
  };

  return (
    <div className="admin-orders">
      <div className="page-header">
        <h2>Управление заказами</h2>
        <div className="orders-stats">
          <span className="stat-pill" style={{background: '#ff6b6b'}}>
            Новых: {orders.filter(o => o.status === 'new').length}
          </span>
          <span className="stat-pill" style={{background: '#4a90e2'}}>
            В работе: {orders.filter(o => o.status === 'processing').length}
          </span>
        </div>
      </div>

      <div className="filters-bar">
        <div className="search-box">
          <FaSearch />
          <input
            type="text"
            placeholder="Поиск по имени или телефону..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
          <option value="all">Все статусы</option>
          <option value="new">Новые</option>
          <option value="processing">В работе</option>
          <option value="completed">Завершенные</option>
          <option value="cancelled">Отмененные</option>
        </select>
      </div>

      {filteredOrders.length === 0 ? (
        <div className="empty-state" style={{background: 'white', padding: '3rem', borderRadius: '15px', textAlign: 'center'}}>
          <p>Заказов не найдено</p>
        </div>
      ) : (
        <div className="orders-table">
          <table>
            <thead>
              <tr>
                <th>Дата</th>
                <th>Клиент</th>
                <th>Телефон</th>
                <th>Товаров</th>
                <th>Сумма</th>
                <th>Статус</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredOrders.map(order => (
              <tr key={order.id}>
                <td>{new Date(order.createdAt).toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})}</td>
                <td><strong>{order.customer?.name || 'Без имени'}</strong></td>
                <td>{order.customer?.phone || '-'}</td>
                <td>{order.totalItems} шт.</td>
                <td><strong>{order.totalPrice}₽</strong></td>
                <td>
                  <select
                    value={order.status}
                    onChange={(e) => handleStatusChange(order.id, e.target.value)}
                    className="status-select"
                    style={{borderColor: getStatusColor(order.status)}}
                  >
                    <option value="new">Новый</option>
                    <option value="processing">В работе</option>
                    <option value="completed">Завершен</option>
                    <option value="cancelled">Отменен</option>
                  </select>
                </td>
                <td>
                  <button className="btn-icon btn-view" onClick={() => setSelectedOrder(order)}>
                    <FaEye />
                  </button>
                </td>
              </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedOrder && (
        <div className="modal-overlay" onClick={() => setSelectedOrder(null)}>
          <div className="modal-content modal-large" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Заказ #{selectedOrder.id.slice(0, 8)}</h3>
              <button className="btn-icon" onClick={() => setSelectedOrder(null)}><FaTimes /></button>
            </div>

            <div className="order-details">
              <div className="order-section">
                <h4>Информация о клиенте</h4>
                <div className="info-grid">
                  <div className="info-item">
                    <FaPhone />
                    <div>
                      <label>Телефон</label>
                      <span>{selectedOrder.customer?.phone}</span>
                    </div>
                  </div>
                  {selectedOrder.customer?.email && (
                    <div className="info-item">
                      <FaEnvelope />
                      <div>
                        <label>Email</label>
                        <span>{selectedOrder.customer.email}</span>
                      </div>
                    </div>
                  )}
                  <div className="info-item">
                    <FaMapMarkerAlt />
                    <div>
                      <label>Адрес доставки</label>
                      <span>{selectedOrder.customer?.address}</span>
                    </div>
                  </div>
                  {selectedOrder.customer?.comment && (
                    <div className="info-item full-width">
                      <FaComment />
                      <div>
                        <label>Комментарий клиента</label>
                        <span>{selectedOrder.customer.comment}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="order-section">
                <h4>Состав заказа</h4>
                <table className="order-items-table">
                  <thead>
                    <tr>
                      <th>Товар</th>
                      <th>Цена</th>
                      <th>Количество</th>
                      <th>Сумма</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.items.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.name}</td>
                        <td>{item.price}</td>
                        <td>{item.quantity}</td>
                        <td><strong>{parseInt(item.price) * item.quantity}₽</strong></td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3"><strong>Итого:</strong></td>
                      <td><strong>{selectedOrder.totalPrice}₽</strong></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="order-section">
                <h4>Комментарии администратора</h4>
                {selectedOrder.adminComments && selectedOrder.adminComments.length > 0 && (
                  <div className="comments-list">
                    {selectedOrder.adminComments.map((comment, idx) => (
                      <div key={idx} className="comment-item">
                        <div className="comment-date">{new Date(comment.date).toLocaleString('ru-RU')}</div>
                        <div className="comment-text">{comment.text}</div>
                      </div>
                    ))}
                  </div>
                )}
                <div className="comment-form">
                  <textarea
                    placeholder="Добавить комментарий..."
                    value={adminComment}
                    onChange={(e) => setAdminComment(e.target.value)}
                    rows="3"
                  />
                  <button 
                    className="btn-primary"
                    onClick={() => handleAddComment(selectedOrder.id)}
                    disabled={!adminComment.trim()}
                  >
                    Добавить комментарий
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminOrders;
